import {ColumnsType} from "antd/es/table";
import {Link} from "react-router-dom";
import {Amount} from "../../../models/amount/amount";
import {Price} from "../../core/commons/price/price";
import React from "react";
import {TFunction} from "react-i18next";
import {Space, Tooltip} from "antd";
import {AddToCartAction} from "../ui/button/add-to-cart-action/add-to-cart-action";
import {AddToWishlistAction} from "../ui/button/add-to-wishlist-action/add-to-cart-action";
import {TableRow} from "./catalog.oem-search-result";
import {FullReplacementIcon} from "./icons/full-replacement.icon";
import {PartialReplacementIcon} from "./icons/partial-replacement.icon";

export const columnsFactory = (t: TFunction<"translation">, warehouses: Set<string>): ColumnsType<TableRow> => {
    const columns: ColumnsType<TableRow> = [
        {
            title: 'Requested No',
            dataIndex: 'requestedName'
        },
        {
            title: t("ARTICLES.TITLE_SINGLE"),
            dataIndex: "name",
            key: "name",
            width: "140px",
            render: (item: string, row: TableRow) => row.found ? (
                <span style={{display: "inline-flex", alignItems: "center", gap: 10, height: 12}}>
                    {row.replacement === "full" ? (
                        <Tooltip title={"Full replacement"}>
                            <FullReplacementIcon/>
                        </Tooltip>
                    ) : (
                        <Tooltip title={"Partial replacement"}>
                            <PartialReplacementIcon/>
                        </Tooltip>
                    )}
                    <Link className="link" to={"catalog/article/" + item}>{item}</Link>
                </span>
            ) : '-'
    },
    {
        title: t("ARTICLES.NAME"),
            dataIndex
    :
        "description",
            key
    :
        "description",
            className
    :
        "catalog-table-description"
        }
    ];

    warehouses.forEach(warehouse => {
        columns.push({
            title: warehouse,
            dataIndex: warehouse,
            key: warehouse,
            render: (_: any, row: TableRow) => {
                if (row.found && row.stock) {
                    const foundWarehouse = row.stock.find(item => item.warehouse === warehouse);
                    return foundWarehouse ? String(foundWarehouse.amount) : "0";
                } else {
                    return '-'
                }
            }
        });
    });

    columns.push(
        {
            title: t("PRICE"),
            dataIndex: "amount",
            key: "amount",
            render: (price: Amount, row: TableRow) => row.found ? (
                <Price value={price} />
            ): '-'
        },
        {
            title: "",
            key: "actions",
            width: "100px",
            className: "catalog-table-btn",
            render: (_: any, row: TableRow) => row.found ? (
                <Space direction={"horizontal"} size={[20, 20]}>
                    <AddToCartAction article={row} />
                    <AddToWishlistAction article={row} />
                </Space>

            ) : null
        }
    );

    return columns;
}